import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import {
  DataUpIcon,
  Share,
  WhiteSupportIcon,
} from "../../assets/icons";
import { useAppSelector } from "../../hooks/hooks";
import { normalizeReferralCode, shareAppLink } from "../../utils/referral";

const Invitation = () => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user);
  const referralCode = normalizeReferralCode(user?.referral_code);

  const shareLink = async () => {
    try {
      const result = await shareAppLink(referralCode);
      if (result === "copied") {
        toast.success("Link copied to clipboard.");
      }
    } catch (error) {
      toast.error("Unable to share the link.");
    }
  };

  return (
    <div
      className="relative py-8 px-5 rounded-xl flex flex-col gap-8"
      style={{
        backgroundImage: `url(/images/invitation.jpeg)`,
        backgroundPosition: "center top",
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
      }}
    >
      <img
        src="/png/IVCartoon.png"
        alt=""
        className="absolute -top-4 -right-2 size-24 bp:size-32 bp:-top-8 bp:-right-3 transform scale-x-[-1] z-0"
      />
      <div className="flex flex-col gap-4">
        <DataUpIcon />
        <span className="lt-xl-medium-white z-10 max-w-[75%] bp:max-w-[80%] leading-snug">
          Invite your friends and family to join the DataUp Family
        </span>
        {referralCode && (
          <div className="z-10 flex items-center gap-2 text-white text-sm">
            <span className="opacity-80">Your code:</span>
            <span className="font-bold tracking-wide">{referralCode}</span>
          </div>
        )}
      </div>

      <div className="flex flex-col sm:flex-row gap-4 z-10 items-center justify-center">
        {/* Share Link Button */}
        <button
          className="flex w-full bp:flex-1 items-center justify-center gap-3 h-14 sm:h-11 rounded-xl px-6 bg-white hover:bg-opacity-90 active:scale-[0.98] transition-all shadow-md"
          onClick={shareLink}
          type="button"
        >
          <span className="satoshi-sm-bold-toggleBG-dark">Share Link</span>
          <Share />
        </button>

        {/* Contact Support Button */}
        <button
          className="flex w-full bp:flex-1 items-center justify-center gap-3 h-14 sm:h-11 rounded-xl px-6 bg-white/20 backdrop-blur-md border border-white/40 hover:bg-white/25 active:scale-[0.98] transition-all shadow-md"
          onClick={() => navigate("/support")}
          type="button"
        >
          <span className="satoshi-sm-bold-white">Contact Support</span>
          <div className="size-5 flex items-center justify-center text-white fill-current">
            <WhiteSupportIcon />
          </div>
        </button>
      </div>
    </div>
  );
};

export default Invitation;
